import { ApiError } from "@/api/errors";
import { QueryClient } from "@tanstack/react-query";

const NON_RETRIABLE = new Set([400, 401, 403, 404, 409, 422]);

function shouldRetry(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && error.status !== undefined && NON_RETRIABLE.has(error.status)) {
    return false;
  }
  return failureCount < 3;
}

function retryDelayMs(attempt: number): number {
  return Math.min(1_000 * 2 ** attempt, 15_000);
}

function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        networkMode: "offlineFirst",
        retry: shouldRetry,
        retryDelay: retryDelayMs,
        staleTime: 60_000,
        gcTime: 24 * 60 * 60_000,
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
      },
      mutations: {
        networkMode: "offlineFirst",
        retry: false,
      },
    },
  });
}

export const queryClient = createQueryClient();
